import type { SortByValue } from '../../modules/listing/components/reviews/ReviewListItems';
import type { GTMEventReturnType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

export interface GTMDetailSortReviewsChangeModelData {
    readonly sortBy: SortByValue;
}

interface GTMDetailSortReviewsChangeReturnType extends GTMEventReturnType {
    readonly sort_by: SortByValue;
}

export default class GTMDetailSortReviewsChangeModel extends GTMBaseModel {
    public static parseToGTMData({
        sortBy
    }: GTMDetailSortReviewsChangeModelData): GTMDetailSortReviewsChangeReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'cro_event',
            ga4_event_name: 'detail_sort_reviews_change',
            sort_by: sortBy
        };
    }
}
